import {configureStore, ThunkAction, Action}	from '@reduxjs/toolkit';

import user 									from '../redux/user/user';
import devices									from '../redux/devices/devices';
import companyUsers 							from '../redux/companyUsers/companyUsers';
import contracts 								from '../redux/contracts/contracts';
import documents 								from '../redux/documents/documents';
import company									from '../redux/company/company';
import address									from '../redux/address/address';
import order									from '../redux/order/order';
import dashboard								from '../redux/dashboard/dashboard';
import support									from '../redux/support/support';
import basket 									from '../redux/basket/basket';
import contractsNotValala						from '../redux/contractsNotValala/contractsNotValala';
import companyBundle 							from '../redux/companyBundle/companyBundle';
import notifications 							from '../redux/notifications/notifications';
import settings 								from '../redux/settings/settings';
import mobileLines from '../redux/mobileLines/mobileLines';
import {mobileLineListenerMiddleware} from '../redux/mobileLines/mobileLinesListener';

export const store = configureStore({
	reducer: {
		user,
		order,
		basket,
		support,
		devices,
		company,
		address,
		settings,
		dashboard,
		contracts,
		documents,
		companyUsers,
		companyBundle,
		notifications,
		contractsNotValala,
		mobileLines
	},
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware().prepend(mobileLineListenerMiddleware.middleware)
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
